var map = {
	"./Home.vue": [
		3041,
		318,
		508
	],
	"./Order.vue": [
		7867,
		318,
		912,
		901
	],
	"./Orders.vue": [
		6408,
		318,
		912,
		875
	],
	"./Pending.vue": [
		9893,
		318,
		912,
		501
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;